export default __webpack_public_path__ + "static/media/pageClose.016e11ba.mp3";